const OfflineSection = () => {
  return (
    <div className="flex justify-center">
      <div className="flex justify-center bg-gray-400 text-black w-1/3 text-lg">
        You are offline, please check your internet connection
      </div>
    </div>
  );
};

export default OfflineSection;
